// https://qiita.com/hanlio/items/cc7d7707f78ef544749d
export const hankaku = (str: string) => {
  if (!str) {
    return str;
  }

  const clean = str.replaceAll(/[０-９Ａ-Ｚａ-ｚ]/g, (s) => String.fromCodePoint(s.codePointAt(0) - 0xfee0));
  return clean.replaceAll(/[‐—−ー－]/g, () => '-');
};
